import { render, staticRenderFns } from "./SqlDetailPane.vue?vue&type=template&id=80f492e0&"
import script from "./SqlDetailPane.vue?vue&type=script&lang=js&"
export * from "./SqlDetailPane.vue?vue&type=script&lang=js&"
import style0 from "./SqlDetailPane.vue?vue&type=style&index=0&id=80f492e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports